import React, { useEffect, useRef } from 'react';

interface FrameGuardProps {
  children: React.ReactNode;
}

const FrameGuard: React.FC<FrameGuardProps> = ({ children }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkForMaliciousIframes = () => {
      const iframes = document.getElementsByTagName('iframe');
      for (let i = 0; i < iframes.length; i++) {
        const iframe = iframes[i];
        
        // Skip reCAPTCHA iframes
        if (iframe.src && (
          iframe.src.includes('google.com/recaptcha') ||
          iframe.src.includes('gstatic.com/recaptcha')
        )) {
          continue;
        }

        // Check for suspicious iframe attributes
        if (
          (iframe.style.position === 'fixed' || iframe.style.position === 'absolute') && 
          (parseInt(iframe.style.zIndex) > 1000000 || iframe.style.zIndex === '2147483647') &&
          (iframe.style.width === '100%' || iframe.style.width === '100vw') &&
          (iframe.style.height === '100%' || iframe.style.height === '100vh') &&
          (!iframe.src || iframe.src === '') &&
          (!iframe.srcdoc || iframe.srcdoc === '')
        ) {
          iframe.remove();
          console.warn('Removed suspicious iframe');
        }
      }
    };

    // Set up mutation observer to watch for DOM changes
    const observer = new MutationObserver((mutations) => {
      checkForMaliciousIframes();
    });

    // Start observing the document with the configured parameters
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'src', 'srcdoc']
    });

    // Run initial check
    checkForMaliciousIframes();

    // Additional check on window load
    window.addEventListener('load', checkForMaliciousIframes);

    // Periodic check every 2 seconds
    const intervalId = setInterval(checkForMaliciousIframes, 2000);

    // Cleanup
    return () => {
      observer.disconnect();
      window.removeEventListener('load', checkForMaliciousIframes);
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div ref={containerRef} style={{ position: 'relative', width: '100%', height: '100%' }}>
      {children}
    </div>
  );
};

export default FrameGuard; 